import React, { useState } from 'react';
import EventCard from "./sections/EventCards";
import EventTable from "./sections/EventTable";
import AddEventModal from "./sections/modals/AddEventModal";
import ViewEventModal from "./sections/modals/ViewEventModal";
import EditEventModal from "./sections/modals/EditEventModal";
import AddProductsModal from "./sections/modals/AddProductsModal";

/**
 * Catering Package Management Page
 * Displays catering package statistics and table with add functionality
 */
const EventCateringPage = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isAddProductsModalVisible, setIsAddProductsModalVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);


  // Handle modal actions
  const handleAddEvent = () => {
    setIsAddModalVisible(true);
  };

  const handleCloseAddModal = () => {
    setIsAddModalVisible(false);
  };

  const handleAddSuccess = () => {
    // Package was created successfully, table will auto-refresh
    // console.log('Package created successfully');
  };

  const handleEditEvent = (record) => {
    setSelectedEvent(record);
    setIsEditModalVisible(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedEvent(null);
  };

  const handleEditSuccess = () => {
    // Package was updated successfully, table will auto-refresh
    // console.log('Package updated successfully');
  };

  const handleViewEvent = (record) => {
    setSelectedEvent(record);
    setIsViewModalVisible(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalVisible(false);
    setSelectedEvent(null);
  };

  const handleAddProducts = (record) => {
    setSelectedEvent(record);
    setIsAddProductsModalVisible(true);
  };

  const handleCloseAddProductsModal = () => {
    setIsAddProductsModalVisible(false);
    setSelectedEvent(null);
  };

  const handleAddProductsSuccess = () => {
    // Products were added successfully
    // console.log('Products added successfully');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-8">
        <div className='flex flex-col gap-6'>
          {/* Catering Package Statistics Cards */}
          <EventCard />
          
          {/* Catering Package Table */}
          <EventTable
            onAddEvent={handleAddEvent}
            onEditEvent={handleEditEvent}
            onViewEvent={handleViewEvent}
            onAddProducts={handleAddProducts}
          />
        </div>
      </div>

      {/* Add Package Modal */}
      <AddEventModal
        visible={isAddModalVisible}
        onCancel={handleCloseAddModal}
        onSuccess={handleAddSuccess}
      />

      {/* View Package Modal */}
      <ViewEventModal
        visible={isViewModalVisible}
        onCancel={handleCloseViewModal}
        eventData={selectedEvent}
      />

      {/* Edit Package Modal */}
      <EditEventModal
        visible={isEditModalVisible}
        onCancel={handleCloseEditModal}
        onSuccess={handleEditSuccess}
        eventData={selectedEvent}
      />

      {/* Add Products Modal */}
      <AddProductsModal
        visible={isAddProductsModalVisible}
        onCancel={handleCloseAddProductsModal}
        onSuccess={handleAddProductsSuccess}
        packageData={selectedEvent}
      />
    </div>
  );
};

export default EventCateringPage;